import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {selectHasClientPermission} from '../../utils/permissionsUtils';

export const useHasClientPermission = (
  clientId: string,
  permissionCode: string
) => {
  return useSelector((state: RootState) =>
    selectHasClientPermission(state, clientId, permissionCode)
  );
};
